import { CommonModule } from '@angular/common';
import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { GoMaterialModule } from '@go-modules/go-material.module';
import { TranslateModule } from '@ngx-translate/core';
import { DashboardHeaderComponent } from './dashboard-header/dashboard-header.component';
import { BreadcrumbsModule } from '../breadcrumbs/breadcrumbs.module';
import { DashboardNavigationComponent } from './dashboard-navigation/dashboard-navigation.component';
import { AlphabeticalByKeyPipeModule } from '@go-modules/pipes/alphabetical/alphabetical-by-key-pipe.module';
import { DashboardComponent } from './dashboard.component';
import { HTTP_INTERCEPTORS, provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import { CustomParamsDialogModule } from '@go-modules/components/dialogs/custom-params-dialog/custom-params-dialog.module';
import { RateLimitInterceptor } from '@go-modules/services/interceptors/rate-limit-interceptor/rate-limit-interceptor.service';
import { CustomerSurveySnackBarModule } from '@go-modules/components/snack-bars/customer-survey/customer-survey-snack-bar.module';
import { AiTrialSurveySnackBarModule } from '@go-modules/components/snack-bars/ai-trial-survey/ai-trial-survey-snack-bar.module';
import { SurveySnackBarModule } from '@go-modules/components/snack-bars/survey/survey-snack-bar.module';
import { DraftTourSnackBarModule } from '@go-modules/components/snack-bars/draft-tour/draft-tour-snack-bar.module';
import { HeyGenPromptEditorComponentModule } from '../hey-gen-prompt-editor/hey-gen-prompt-editor.module';
import { FeatureFlagDialogComponentModule } from '@go-modules/components/dialogs/feature-flag-dialog/feature-flag-dialog.module';
import { FeaturedMessageModule } from '@go-modules/components/featured-message/featured-message.module';
import { DownloadPWADialogModule } from '../dialogs/download-pwa';
import { AbbreviateOrgNamePipe } from '@go-modules/pipes/abbreviate-org-name/abbreviate-org-name.pipe';
import { LogoComponent } from '../logo/logo.component';

@NgModule({ declarations: [
	DashboardComponent,
	DashboardHeaderComponent,
	DashboardNavigationComponent
],
exports: [
	DashboardComponent,
	DashboardHeaderComponent,
	DashboardNavigationComponent
], imports: [
	CommonModule,
	TranslateModule,
	GoMaterialModule,
	BreadcrumbsModule,
	AlphabeticalByKeyPipeModule,
	CustomParamsDialogModule,
	CustomerSurveySnackBarModule,
	AiTrialSurveySnackBarModule,
	SurveySnackBarModule,
	DraftTourSnackBarModule,
	HeyGenPromptEditorComponentModule,
	FeatureFlagDialogComponentModule,
	FeaturedMessageModule,
	DownloadPWADialogModule,
	AbbreviateOrgNamePipe,
	LogoComponent
], providers: [
	{ provide: HTTP_INTERCEPTORS, useClass: RateLimitInterceptor, multi: true },
	provideHttpClient(withInterceptorsFromDi())
], schemas: [CUSTOM_ELEMENTS_SCHEMA] })
export class DashboardModule {}
